import cloneDeep from 'lodash/cloneDeep';

export const isMobilePhone = (tel: string): boolean => {
  if (tel.length < 11) return false;
  const required = ['090', '080', '070'];
  if (!required.includes(tel.substr(0, 3))) return false;
  return true;
};
